import { apiClient, bearer, unwrap } from './client';
import type { components } from './types';

export type InvitationOut = components['schemas']['InvitationOut'];

export function createInvitation(
  slug: string,
  email: string,
  idToken: string,
): Promise<InvitationOut> {
  return apiClient
    .POST('/api/customers/{slug}/invitations', {
      params: { path: { slug } },
      body: { email },
      headers: bearer(idToken),
    })
    .then(unwrap<InvitationOut>);
}
